/**
 * 计算table的高度，并自动更新
 */
function calcContentCardSize(){
  const ELEMENT_CONTAINER_BODY = '.content-card .content-body'
  const ELEMENT_CONTAINER_BODY_DIV = ELEMENT_CONTAINER_BODY + ' > div'
  const ELEMENT_CONTAINER_FOOTER = '.content-card .content-footer'
  const ELEMENT_TABS_IFRAME_BODY = '.iframe-mode-disable ' //放在tabs 内容项 iframe中的列表
  if($(ELEMENT_CONTAINER_BODY).length){
    var topDistance = $(ELEMENT_CONTAINER_BODY).offset().top;
    // console.log('topDistance',topDistance)
    var footerHeight = $(ELEMENT_CONTAINER_FOOTER).length > 0 && $(ELEMENT_CONTAINER_FOOTER).get(0).offsetHeight;
    // console.log('footerHeight',footerHeight)
    var cusOffset = 16 + 15;
    var isTabsIframePage = $(ELEMENT_TABS_IFRAME_BODY).length>0?true:false
    if(isTabsIframePage){
      cusOffset = 0
    }
    /*console.log($(ELEMENT_CONTAINER_BODY).height())
    console.log('topDistance:', topDistance);
    console.log('footerHeight:', footerHeight);
    console.log('cusOffset:', cusOffset);*/
    var tableHeight = window.innerHeight - topDistance - footerHeight
    //console.log('window.innerHeight:', window.innerHeight)
    //console.log('tableHeight:', tableHeight)
    //表格高度大于可显示最大高度时，设置最大高度
    if($(ELEMENT_CONTAINER_BODY_DIV).height() > tableHeight){
      $(ELEMENT_CONTAINER_BODY).css('height', tableHeight + 'px');
      $(ELEMENT_CONTAINER_BODY).css('overflow-y', 'scroll')
    } else {
      $(ELEMENT_CONTAINER_BODY).css('height', 'auto');
      $(ELEMENT_CONTAINER_BODY).css('overflow-y', 'auto')
    }
    //console.log('窗口宽：' + window.innerWidth, '窗口高：' + window.innerHeight, '设置高:' + tableHeight)
  }
}
export  default calcContentCardSize
